<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M9.7 3.5Q8 3.5 7 4.6A3.7 3.7 0 0 0 7 10a4 4 0 0 0 5.4 0 3.7 3.7 0 0 0 0-5.3 4 4 0 0 0-2.7-1.1m6.7 7.6h-.2v.2l-.3 1.2-.8.4-1.2-.4-.3.1-1 1.6.1.3 1 .8v1l-1 .7v.3l1 1.7h.2l1.2-.4.8.5.2 1.2q0 .2.3.2h1.9q.2 0 .2-.2l.2-1.2.8-.5 1.2.5.3-.1 1-1.7V17l-1.1-.7v-1l1-.8v-.3l-.9-1.6-.3-.1-1.2.4-.8-.4-.2-1.2V11h-2.2m-6.7 1.8C5.4 13 2 14.6 2 16.7v2h9.3a7 7 0 0 1 0-5.7zm7.6 1.5q1.4.1 1.5 1.4-.2 1.3-1.5 1.4Q16 17 16 15.8q.1-1.3 1.4-1.4"
    />
  </svg>
</template>
